export * from "./svg-icon.module"
